import { tt } from "../../../utils/i18n/i18n";

export function buildNameForRepeatBusiness(_id: any) {
  switch (_id) {
    case "nRedeemed":
      return tt("redeem_voucher");
    case "nOCR":
      return tt("ocr_legend");
    default:
      return "";
  }
}
